// extracted by css-extract-rspack-plugin
export default {"captionComponentSection":"ReviewCaptionStyles-module__captionComponentSection","name":"ReviewCaptionStyles-module__name","rating":"ReviewCaptionStyles-module__rating"};